import api from './axiosConfig';

export interface DocumentTypeItem {
  id: string;
  documentTypeName: string;
  description?: string;
  expiryRequired: boolean;
  isActive: boolean;
}

export interface SaveDocumentTypePayload {
  documentTypeName: string;
  description?: string;
  expiryRequired: boolean;
  isActive: boolean;
}

export interface ExpiryNotificationSettings {
  id?: string;
  notificationBeforeDays: number;
  emailNotification: boolean;
  smsNotification: boolean;
  systemNotification: boolean;
  isActive: boolean;
}

export const documentManagementApi = {
  getDocumentTypes: async (): Promise<DocumentTypeItem[]> => {
    const response = await api.get<DocumentTypeItem[]>('/document-types');
    return response.data;
  },

  createDocumentType: async (payload: SaveDocumentTypePayload): Promise<{ id: string; message: string }> => {
    const response = await api.post<{ id: string; message: string }>('/document-types', payload);
    return response.data;
  },

  updateDocumentType: async (id: string, payload: SaveDocumentTypePayload): Promise<void> => {
    await api.put(`/document-types/${id}`, { id, ...payload });
  },

  getExpiryNotificationSettings: async (): Promise<ExpiryNotificationSettings> => {
    const response = await api.get<ExpiryNotificationSettings>('/expiry-notification-settings');
    return response.data;
  },

  saveExpiryNotificationSettings: async (payload: ExpiryNotificationSettings): Promise<void> => {
    await api.post('/expiry-notification-settings', payload);
  },
};
